import { z } from "zod";

export const getMailboxParamsSchema = z.object({
	// A mailbox id is a uuid and every read reaches a uuid column, so anything else is a bad
	// request rather than a lookup that fails inside the database.
	mailboxId: z.uuid(),
});

export type GetMailboxParamsSchema = z.infer<typeof getMailboxParamsSchema>;
